export default "__VITE_PUBLIC_ASSET__001bb057__"